module.exports = __webpack_public_path__ + "static/img/iphone_ldtpage3.c9c5973.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/iphone_ldtpage3.png
// module id = Qizz
// module chunks = 0